import { observer } from 'mobx-react-lite';
import Box from '@client/uikit/Box';
import Frame from '@client/uikit/Frame';
import HomeBriefButton from '../brief/HomeBriefButton';
import Jsonld from '../Jsonld';
import MetaHeader from '@client/component/MetaHeader';
import MyStrategyList from './MyStrategyList';
import FeaturedStockCard from '../featured/FeaturedStockCard';
import NewsList from '../news/NewsList';
import firebaseStore from '@client/stores/firebaseStore';

const HomePage = observer(() => {
    const description =
        '나만의 투자 전략을 만들고 다른 투자자들과 성과를 비교해보세요. 해와오 챌린지에 참여하여 최고의 전략을 찾아보세요.';

    return (
        <Frame>
            <MetaHeader
                title="해와오 - 해외투자와 포트폴리오"
                description={description}
                keepTitle={true}
            />
            <Jsonld
                type="WebSite"
                title="해와오 - 해외투자와 포트폴리오"
                description={description}
                keepTitle={true}
            />
            <Jsonld type="Organization" title="해와오" />

            {/* 홈브리프 버튼 */}
            <Box>
                <HomeBriefButton />
            </Box>

            <Box>
                <Box.Title title="화제의 종목" />
                <section className="-mx-5">
                    <FeaturedStockCard />
                </section>
            </Box>

            <Box>
                <Box.Title title="주요 해외뉴스" />
                <NewsList displayCount={5} isShowMoreButton={false} />
                <Box.More link="/news">더보기</Box.More>
            </Box>

            {/* 내 전략 섹션 */}
            {firebaseStore.isAdmin && <MyStrategyList />}

            {/* TODO: 챌린지 랭킹 프리뷰 - 추후 구현 */}

            <Frame.Spacer />
            {/* 전략 배포 후 주석 삭제
            <div className="text-base-content/40 px-5 text-sm">
                <div className="font-semibold">면책 사항</div>
                해와오는 투자자 개인의 의견을 공유하고 투자 아이디어를 테스트하는 플랫폼입니다. 투자
                권유나 자문을 제공하지 않으며, 제공되는 정보는 투자 판단의 참고 자료일 뿐 정확성이나
                수익을 보장하지 않습니다. 모든 투자 결정과 그에 따른 손익은 투자자 본인의
                책임입니다.
            </div>
            */}
        </Frame>
    );
});

export default HomePage;
